export default __webpack_public_path__ + "static/media/Plaid.585b2d1d.png";